import React from 'react';
import { useTranslate } from '../../../../core/translate';

const PaymentEstimatorForm = () => {
  const translate = useTranslate();

  const financeCtaTemplate = `
<script is="gmwc-template" type="text/html" id="byo-finance-cta-template">
  <a slot="finance-cta" href="https://www.intelliprice.com/intellipricedealer/start.htm?dealerid=3045202" target="_window">
    <gm-translate>financedetailbox.tradeInLink</gm-translate>
  </a>
</script>`;

  const modalCtaTemplate = `
<script is="gmwc-template" type="template" id="byo-modal-cta-template">
  <span slot="modal-title" class="modal-title">${translate(
    'pe.rewards.modal.header.v3'
  )}</span>
  <button slot="modal-close" class="modal-close" onclick="actionDismiss">${translate(
    'pe.rewards.modal.header.close.v3'
  )}</button>
  <div slot="modal-content" class="modal-content">
    <gmst-modal></gmst-modal>
  </div>
</script>`;

  if (!document.getElementById('byo-finance-cta-template')) {
    const body = document.getElementsByTagName('body')[0];
    body.insertAdjacentHTML('beforeend', financeCtaTemplate);
  }

  if (!document.getElementById('byo-modal-cta-template')) {
    const body = document.getElementsByTagName('body')[0];
    body.insertAdjacentHTML('beforeend', modalCtaTemplate);
  }

  return (
    <gmst-pe-financedetailbox
      unlock-other-credits-input="false"
      modal-template="byo-modal-cta-template"
      finance-cta-template="byo-finance-cta-template"
    />
  );
};

export default PaymentEstimatorForm;
